import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CardText from "../../components/CardText";

const Insights = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Run once to ensure it's accurate even after initial render
    handleResize();

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile) {
    return (
      <div>
        <div></div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="page-hero-text-wrapper">
        <div className="page-hero-text">Insights</div>
      </div>
      <div className="page-body-wrapper">
        <div className="insights-cards-wrapper">
          <div className="insights-card-wrapper">
            <div className="insights-card-title">Updates</div>
            <div className="insights-card-img-wrapper">
              <Link className="insights-card-img-link-wrapper" to="/insights/updates">
                <CardText type="updates" />
              </Link>
            </div>
          </div>
          <div className="insights-card-wrapper">
            <div className="insights-card-title">News</div>
            <div className="insights-card-img-wrapper">
              <Link className="insights-card-img-link-wrapper" to="/insights/news">
                <CardText type="news" />
              </Link>
            </div>
          </div>
          <div className="insights-card-wrapper">
            <div className="insights-card-title">Useful Links</div>
            <div className="insights-card-img-wrapper">
              <Link className="insights-card-img-link-wrapper" to="/insights/useful-links">
                <img className="insights-card" alt="quick-links"/>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insights;
